module.exports = __webpack_public_path__ + "img/PRI.418b9821.gif";